import classNames from 'classnames';
import { CSSProperties, useEffect } from 'react';
import * as bd from 'react-basic-design';
import { useSearchUsersApi } from '../../api/users-api';
import SvgAdd from '../../assets/icons/Add';
import { CellChip } from '../basic/cell-chip';
import { T, translate } from '../basic/text';
import { BasicModal } from '../basic/basic-modal';

export const SelectUserModal = ({
    show,
    onHide,
    onChange,
}: {
    show: boolean;
    onHide: VoidFunction;
    onChange: ({ userName, displayName }: { userName: string; displayName: string }) => void;
}) => {
    const searchUsersApi = useSearchUsersApi();

    useEffect(() => {
        if (!show || searchUsersApi.result) return;
        searchUsersApi.post(null, {});
    }, [searchUsersApi, show]);

    if (!show) return <></>;

    const style: CSSProperties = { fontSize: '0.70rem' };

    return (
        <bd.Flex align="start" vertical>
            <BasicModal title={translate('select-user')} show={show} onHide={onHide} closeButton>
                <bd.Flex align="center">
                    <bd.List className="w-100">
                        {searchUsersApi.result &&
                            searchUsersApi.result.list.map((user, index) => (
                                <>
                                    {index > 0 && <bd.ListDivider />}
                                    <bd.ListItem
                                        compact
                                        className={classNames('w-100 rounded', {
                                            'bg-gray-5 opacity-75': user.isDisabled,
                                        })}
                                        primary={
                                            <bd.Flex align="center" gap={2}>
                                                <span>{user.displayName}</span>
                                                <span className="text-muted">
                                                    ({user.userName})
                                                </span>
                                                {user.isServiceUser && (
                                                    <CellChip
                                                        label="service"
                                                        color="info"
                                                        disabled
                                                    />
                                                )}
                                            </bd.Flex>
                                        }
                                        controls={
                                            <>
                                                {user.isDeleted && (
                                                    <CellChip
                                                        label="deleted"
                                                        color="red"
                                                        disabled
                                                    />
                                                )}
                                                {user.isDisabled && (
                                                    <CellChip label="disabled" disabled />
                                                )}
                                                {!user.isDisabled && !user.isDeleted && (
                                                    <bd.Button
                                                        variant="outline"
                                                        pill
                                                        size="sm"
                                                        disabled={user.isDisabled || user.isDeleted}
                                                        disableRipple
                                                        edge="end"
                                                        onClick={() => {
                                                            user.userName &&
                                                                user.displayName &&
                                                                onChange({
                                                                    userName: user.userName,
                                                                    displayName: user.displayName,
                                                                });
                                                            onHide();
                                                        }}
                                                    >
                                                        <bd.Flex align="center" style={style}>
                                                            <SvgAdd className="ms-2" />
                                                            <T>select-user</T>
                                                        </bd.Flex>
                                                    </bd.Button>
                                                )}
                                            </>
                                        }
                                    />
                                </>
                            ))}
                    </bd.List>
                </bd.Flex>
            </BasicModal>
        </bd.Flex>
    );
};
